import { render, staticRenderFns } from "./DonationFooter.vue?vue&type=template&id=67b07dc8&"
import script from "./DonationFooter.vue?vue&type=script&lang=js&"
export * from "./DonationFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports